import React, { useEffect, Children } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, MessageCircle, Gift, Download } from 'lucide-react';
// --- CONFIGURABLE VARIABLES ---
const WHATSAPP_LINK = 'https://wa.me/XXXXXXXXXXX';
const VSL_LINK = 'https://www.youtube.com/watch?v=XXXXXXXX';
const PDF_LINK = 'https://assets.cdn.filesafe.space/VPeOQro95PyIFiaEYd4a/media/69921921a9efde433478cd1d.pdf';
// --- ANIMATION VARIANTS ---
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function ThankYouPage() {
  // Fire Meta Pixel "Lead" event on mount
  useEffect(() => {
    if (window.fbq) {
      window.fbq('track', 'Lead');
    }
  }, []);
  return <div style={{
    background: 'var(--bg-deep)',
    minHeight: '100vh',
    width: '100%',
    position: 'relative',
    overflowX: 'hidden',
    paddingBottom: '24px'
  }} data-id="element-206">
      {/* Background Elements */}
      <div className="grid-pattern" style={{
      position: 'absolute',
      inset: 0,
      opacity: 0.3,
      pointerEvents: 'none',
      zIndex: 0
    }} data-id="element-207" />
      <div style={{
      position: 'absolute',
      top: '0%',
      left: '10%',
      width: '500px',
      height: '500px',
      background: 'radial-gradient(circle, rgba(24,163,159,0.12) 0%, transparent 70%)',
      pointerEvents: 'none',
      zIndex: 0
    }} data-id="element-208" />
      <div style={{
      position: 'absolute',
      top: '40%',
      right: '5%',
      width: '400px',
      height: '400px',
      background: 'radial-gradient(circle, rgba(242,42,114,0.08) 0%, transparent 70%)',
      pointerEvents: 'none',
      zIndex: 0
    }} data-id="element-209" />

      <main style={{
      position: 'relative',
      zIndex: 1,
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '40px 16px 24px'
    }} data-id="element-210">
        <motion.div variants={containerVariants} initial="hidden" animate="visible" data-id="element-211">
          {/* HERO SECTION */}
          <motion.section variants={itemVariants} style={{
          textAlign: 'center',
          marginBottom: '32px'
        }} data-id="element-212">
            <h1 style={{
            fontFamily: 'Poppins, sans-serif',
            fontWeight: 900,
            fontSize: 'clamp(30px, 6vw, 56px)',
            color: 'white',
            marginBottom: '12px',
            lineHeight: 1.1,
            letterSpacing: '-0.02em'
          }} data-id="element-213">
              ¡Estás dentro! 🎉
            </h1>

            <p style={{
            color: '#d0d0e0',
            fontSize: 'clamp(15px, 2vw, 20px)',
            fontFamily: 'Inter, sans-serif',
            lineHeight: 1.6,
            maxWidth: '600px',
            margin: '0 auto 10px'
          }} data-id="element-214">
              Tu lugar en el Masterclass está reservado. Mira el video, únete al
              grupo y descarga tu regalo.
            </p>
          </motion.section>

          {/* VIDEO & WHATSAPP MODULES */}
          <motion.section variants={itemVariants} className="modules-grid" style={{
          marginBottom: '32px'
        }} data-id="element-215">
            {/* Video Module */}
            <div className="glass-cyan" style={{
            padding: '24px 20px',
            display: 'flex',
            flexDirection: 'column'
          }} data-id="element-216">
              <h2 style={{
              fontFamily: 'Poppins, sans-serif',
              fontWeight: 800,
              fontSize: '22px',
              color: 'white',
              marginBottom: '6px'
            }} data-id="element-217">
                Mira este video (Importante)
              </h2>
              <p style={{
              color: '#a0a0b0',
              fontSize: '14px',
              fontFamily: 'Inter, sans-serif',
              marginBottom: '16px'
            }} data-id="element-218">
                Te explica qué hacer primero y cómo aprovechar al máximo la
                comunidad.
              </p>

              <div style={{
              width: '100%',
              aspectRatio: '16/9',
              borderRadius: '14px',
              overflow: 'hidden',
              position: 'relative'
            }} data-id="element-219">
                <iframe src="https://player.vimeo.com/video/1177759303?h=ec" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                border: 'none',
                borderRadius: '14px'
              }} allow="autoplay; fullscreen; picture-in-picture" allowFullScreen title="Video importante" data-id="element-220" />
              </div>
            </div>

            {/* WhatsApp Module */}
            <div className="glass-cyan" style={{
            padding: '24px 20px',
            display: 'flex',
            flexDirection: 'column'
          }} data-id="element-221">
              <div style={{
              width: '44px',
              height: '44px',
              borderRadius: '12px',
              background: 'rgba(37,211,102,0.15)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: '16px'
            }} data-id="element-222">
                <MessageCircle size={22} color="#25D366" data-id="element-223" />
              </div>

              <h2 style={{
              fontFamily: 'Poppins, sans-serif',
              fontWeight: 800,
              fontSize: '20px',
              color: 'white',
              marginBottom: '10px',
              lineHeight: 1.3
            }} data-id="element-224">
                Únete al Grupo Privado de WhatsApp
              </h2>
              <p style={{
              color: '#a0a0b0',
              fontSize: '14px',
              fontFamily: 'Inter, sans-serif',
              lineHeight: 1.6,
              marginBottom: '20px'
            }} data-id="element-225">
                Aquí te envío recordatorios, actualizaciones y soporte básico si
                tienes problemas para entrar.
              </p>

              <ul style={{
              listStyle: 'none',
              padding: 0,
              margin: '0 0 24px 0',
              display: 'flex',
              flexDirection: 'column',
              gap: '10px',
              flexGrow: 1
            }} data-id="element-226">
                {['Recordatorios del webinar / entrenamientos', 'Avisos importantes', 'Soporte básico de acceso'].map((item, i) => <li key={i} style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: '10px',
                color: '#d0d0e0',
                fontSize: '14px',
                fontFamily: 'Inter, sans-serif',
                lineHeight: 1.5
              }} data-id="element-227">
                    <CheckCircle2 size={18} color="#25D366" style={{
                  flexShrink: 0,
                  marginTop: '2px'
                }} data-id="element-228" />
                    {item}
                  </li>)}
              </ul>

              <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" style={{
              display: 'block',
              textAlign: 'center',
              background: '#25D366',
              color: 'white',
              fontFamily: 'Poppins, sans-serif',
              fontWeight: 800,
              fontSize: '14px',
              padding: '14px',
              borderRadius: '12px',
              textDecoration: 'none',
              marginBottom: '8px',
              transition: 'background 0.2s'
            }} onMouseEnter={e => e.currentTarget.style.background = '#1ebe5b'} onMouseLeave={e => e.currentTarget.style.background = '#25D366'} data-id="element-229">
                UNIRME AL GRUPO DE WHATSAPP
              </a>
              <p style={{
              textAlign: 'center',
              color: '#6b6b80',
              fontSize: '12px',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-230">
                No spam. Solo info del evento y soporte.
              </p>
            </div>
          </motion.section>

          {/* REGALO — ChatGPT Prompt for Video Scripts */}
          <motion.section variants={itemVariants} style={{
          marginBottom: '32px'
        }} data-id="element-231">
            <div className="glass-cyan" style={{
            padding: '32px 24px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            position: 'relative',
            overflow: 'hidden'
          }} data-id="element-232">
              {/* Gold accent top border */}
              <div style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              height: '3px',
              background: 'linear-gradient(90deg, var(--color-yellow), #d4a017)'
            }} data-id="element-233" />

              <div style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              background: 'rgba(255,226,34,0.1)',
              border: '1px solid rgba(255,226,34,0.3)',
              borderRadius: '100px',
              padding: '6px 16px',
              marginBottom: '16px'
            }} data-id="element-234">
                <Gift size={16} color="var(--color-yellow)" data-id="element-235" />
                <span style={{
                color: 'var(--color-yellow)',
                fontSize: '13px',
                fontWeight: 700,
                fontFamily: 'Poppins, sans-serif',
                letterSpacing: '0.05em'
              }} data-id="element-236">
                  REGALO EXCLUSIVO 🎁
                </span>
              </div>

              <h2 style={{
              fontFamily: 'Poppins, sans-serif',
              fontWeight: 800,
              fontSize: 'clamp(20px, 4vw, 26px)',
              color: 'white',
              marginBottom: '8px',
              lineHeight: 1.2
            }} data-id="element-237">
                Prompt de ChatGPT para Crear Scripts de Videos
              </h2>
              <p style={{
              color: '#a0a0b0',
              fontSize: '15px',
              fontFamily: 'Inter, sans-serif',
              lineHeight: 1.6,
              maxWidth: '520px',
              marginBottom: '24px'
            }} data-id="element-238">
                Descarga este PDF con el prompt exacto que usamos para generar
                scripts de videos virales con inteligencia artificial. Copia,
                pega en ChatGPT y empieza a crear contenido.
              </p>

              <a href={PDF_LINK} download target="_blank" rel="noopener noreferrer" style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '10px',
              background: 'linear-gradient(135deg, #d4a017, #b8860b)',
              color: 'white',
              fontFamily: 'Poppins, sans-serif',
              fontWeight: 800,
              fontSize: '15px',
              padding: '16px 32px',
              borderRadius: '12px',
              textDecoration: 'none',
              boxShadow: '0 0 20px rgba(255,226,34,0.15)',
              transition: 'box-shadow 0.2s, transform 0.2s',
              width: '100%',
              maxWidth: '400px'
            }} onMouseEnter={e => {
              e.currentTarget.style.boxShadow = '0 0 30px rgba(255,226,34,0.3)';
              e.currentTarget.style.transform = 'translateY(-1px)';
            }} onMouseLeave={e => {
              e.currentTarget.style.boxShadow = '0 0 20px rgba(255,226,34,0.15)';
              e.currentTarget.style.transform = 'translateY(0)';
            }} data-id="element-239">
                <Download size={20} data-id="element-240" />
                DESCARGAR MI REGALO GRATIS
              </a>
            </div>
          </motion.section>
        </motion.div>
      </main>

      {/* FOOTER */}
      <footer style={{
      borderTop: '1px solid rgba(255,255,255,0.08)',
      padding: '24px 16px',
      position: 'relative',
      zIndex: 1
    }} data-id="element-241">
        <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '12px',
        textAlign: 'center'
      }} data-id="element-242">
          <p style={{
          color: '#4a4a5a',
          fontSize: '13px',
          fontFamily: 'Inter, sans-serif',
          margin: 0
        }} data-id="element-243">
            © 2026 De Cero a Afiliado. Todos los derechos reservados.
          </p>
        </div>
      </footer>

      <style data-id="element-244">{`
        .modules-grid {
          display: grid;
          grid-template-columns: 1fr;
          gap: 16px;
        }
        
        @media (min-width: 900px) {
          .modules-grid {
            grid-template-columns: 1.5fr 1fr;
            gap: 20px;
          }
        }
      `}</style>
    </div>;
}